export default {"src":"/_next/static/media/AMD.7ac8201a.svg","height":18,"width":18};